"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroceryMapQuery = void 0;
const client_1 = require("@apollo/client");
exports.getGroceryMapQuery = client_1.gql `
  query GetGroceryMap($userId: String!) {
    getGroceryMap(userId: $userId)
  }
`;
//# sourceMappingURL=GetGroceryMap.js.map